module.exports = __webpack_public_path__ + "static/media/buxton-20.dca330e1.jpg";